import { Helmet } from "react-helmet"

function Meta() {
	return (
		<Helmet>
			{/* Page Title */}
			<title>Live Cricket Score & Highlights - CrickStars</title>

			{/* Favicon */}
			<link rel="icon" href="/favicon.ico" />

			{/* Meta Description */}
			<meta name="description" content="Manage cricket like a pro with CrickStars. Score matches, local teams, edit games live & Perfect for clubs, organizers & gully cricket lovers!" />

			{/* Open Graph / Facebook */}
			<meta property="og:title" content="Live Cricket Score & Highlights - CrickStars" />
			<meta property="og:description" content="Manage cricket like a pro with CrickStars. Score matches, local teams, edit games live & Perfect for clubs, organizers & gully cricket lovers!" />
			<meta property="og:image" content="/crickstars.png" />
			<meta property="og:url" content="https://crickstars.in/" />
			<meta property="og:type" content="website" />

			{/* Twitter Card */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content="Live Cricket Score & Highlights - CrickStars" />
			<meta name="twitter:description" content="Manage cricket like a pro with CrickStars. Score matches, local teams, edit games live & Perfect for clubs, organizers & gully cricket lovers!" />
			<meta name="twitter:image" content="/crickstars.png" />

			{/* Mobile responsive support */}
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
			/>

			{/* Font */}
			<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet" />
		</Helmet>
	)
}

export default Meta